import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SvgIcon from "@mui/material/SvgIcon";
import FormHelperText from "@mui/material/FormHelperText";

import {ROUTES} from "../../../../../routes";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import {
  restorePaymentInfo,
  setShippingErrors,
  setShippingInfo
} from "../../../../../actions/paymentFunctions";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartBackButton from "../groheCartBackButton";
import Misc from "../../../../../misc/misc";
import {postVerifyAddress} from "../../../../../api/look-api";
import COLOR_THEMES, {COLORS} from "../../../../../colorThemes";
import {GroheNoteAddIcon} from "../../../../common/icons";
import GroheBillingAndShippingInputs from "./groheBillingAndShippingInputs";
import Analytics from "../../../../../analytics";
import {getAnalyticsEcommerceValues} from "../../../../../analyticsEcommerceParams";
import {IS_DEALER_FLOW} from "../../../../../config";
import {getDealerShipToAddress} from "../../../../../api/cart-api";


const GroheCartShipping = (props) => {

  const {isMobile, history, shippingAddress, setShippingInfo, restorePaymentInfo, setShippingErrors, shippingErrors,
    getDealerShipToAddress, activeTheme} = props;
  const [defaultValues] = useState(shippingAddress);
  const [isLoading, setIsLoading] = useState(false);
  const [shippingInfoLoading, setShippingInfoLoading] = useState(false);
  const [addressError, setAddressError] = useState("");

  const disabled = !shippingAddress.address1 || !shippingAddress.postal || Misc.hasErrors(shippingErrors);

  const backButtonClick = () => {
    restorePaymentInfo({
      shippingAddress: defaultValues
    });
    history.push(IS_DEALER_FLOW ? ROUTES.cart : ROUTES.cartBilling);
  };

  const getShippingInfo = async () => {
    if (!IS_DEALER_FLOW || !document.kvConfig.jobId) {
      return
    }
    setShippingInfoLoading(true);
    await getDealerShipToAddress();
    setShippingInfoLoading(false);
  }

  useEffect(() => {
    getShippingInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const confirmButtonClick = async () => {

    const {currency, value, items} = getAnalyticsEcommerceValues();
    Analytics.sendEcommerceEvent("add_shipping_info", {currency, value, items,
      coupon: "", // "SUMMER_FUN" // we are not using that
      shipping_tier: "", // not sure about it
    });

    setIsLoading(true);
    const addressValidated = await postVerifyAddress(shippingAddress);
    setIsLoading(false);
    if (addressValidated && addressValidated.isConfirmed
      && (addressValidated.isConfirmed === "Y" || addressValidated.isConfirmed === "D")) {
      history.push(IS_DEALER_FLOW ? ROUTES.cartConfirm : ROUTES.cartBilling);
      return true
    }
    setAddressError(addressValidated.errorDescription || " ");
    return false
  };

  const submitButtonTranslateId = IS_DEALER_FLOW ? "buttons.next" : "grohe.cart.shipping.submitButton";
  const startIcon = isLoading
    ? <CircularProgress className="grohe-look__button-loader-small" style={{'color': COLORS.white}}/>
    : (
      <SvgIcon>
        <GroheNoteAddIcon color={COLORS.white}/>
      </SvgIcon>
    )

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: backButtonClick,
    },
    {
      translate: submitButtonTranslateId,
      classes: "look-button--blue gc-sticky__button--60" + (isLoading ? " grohe-look__button--loading" : ""),
      startIcon,
      onClick: confirmButtonClick,
      disabled
    },
  ];

  return (
    <div className="gc">
      <div className="gc-body">
        <GroheCartHeaderCommon title="grohe.cart.shipping.title" subTitle="grohe.cart.shipping.subTitle"/>
        {shippingInfoLoading ? (
          <div style={{height: isMobile ? "auto" : "256px"}} className="flex flex--center">
            <CircularProgress style={{color: COLOR_THEMES[activeTheme].primary}}/>
          </div>
        ) : <GroheBillingAndShippingInputs addressObject={shippingAddress}
                                           shouldSetCountry={true}
                                           setAddressInfo={setShippingInfo}
                                           addressErrors={shippingErrors}
                                           setAddressErrors={setShippingErrors}/>}
        {addressError ? (
          <FormHelperText className="gc-content MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained">
            <FormattedMessage id="look.inputs.errors.incorrectAddress"/>
            {" " + addressError}
          </FormHelperText>
        ) : null}
        {isMobile ? null : (
          <div className="gc-content">
            <div className="gc-form__submit">
              <div className="gc-form__submit-left"/>
              {isMobile ? null : (
                <div className="gc-form__submit-right">
                  <GroheCartBackButton backButtonClick={backButtonClick}/>
                  <Button className={"look-button look-button--blue look-button--big look-button--large nowrap"
                    + (isLoading ? " grohe-look__button--loading" : "")}
                          disabled={disabled}
                          startIcon={startIcon}
                          onClick={confirmButtonClick}>
                    <FormattedMessage id={submitButtonTranslateId}/>
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
        {isMobile ? <div className="gc-spacer"/> : null}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile, activeTheme} = store.serverState;
  const {shippingAddress, shippingErrors} = store.paymentState;

  return {
    isMobile,
    activeTheme,
    shippingAddress,
    shippingErrors,
  };
};

const mapDispatchToProps = {
  setShippingInfo,
  restorePaymentInfo,
  setShippingErrors,
  getDealerShipToAddress,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartShipping))
